import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import ModalDialog from './ModalDialog';

export function showModalDialog({ title, body, type = 'information', buttonType = 'ok' }) {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const ModalWrapper = () => {
      const [open, setOpen] = useState(true);

      const handleClose = (value) => {
        setOpen(false);
        resolve(value);
      };

      useEffect(() => {
        if (!open) {
          setTimeout(() => {
            root.unmount();
            container.remove();
          }, 200);
        }
      }, [open]);

      return (
        <ModalDialog
          open={open}
          title={title}
          body={body}
          type={type}
          buttonType={buttonType}
          onClose={handleClose}
        />
      );
    };

    root.render(<ModalWrapper />);
  });
}
